import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute } from '@angular/router';

import { HelperService } from 'app/services/helper.service';
import { ACLService } from 'app/services/acl.service';
import { HTTPService } from 'app/services/http.service';

import { CookieService } from 'ngx-cookie';
import { Observable } from 'rxjs';
import { DataService } from './data.service';
import { environment } from 'environments/environment';
import { find } from 'lodash';

/**
 * Authorization validation Service
 */
@Injectable()
export class AuthGuard implements CanActivate {
  /**
   * @param  {Router} router Angular Router
   * @param  {CookieService} cookieService Cookie Service
   * @param  {HelperService} helperService Helper Service
   */
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private helperService: HelperService,
    private cookieService: CookieService,
    private httpService: HTTPService,
    private aclService: ACLService,
    public dataService: DataService
  ) {}
  /**
   * @returns {Boolean} Boolean True when user logged in
   */
  canActivate(): boolean | Observable<boolean> {
    return new Observable((observer) => {
      // retrieve token from cookie
      const token = this.cookieService.getObject('alpat');

      // if token not exists
      if (!token) {
        let cid: string;
        let hash: string = window.location.hash || '';
        const query: any = this.helperService.parseQueryParams();

        if (query) {
          if (query.orderingType === 'online' && query.cid) {
            cid = query.cid;
          } else if (hash.startsWith('#/estimate/') && query.tab) {
            cid = this.cookieService.get('cid');
          }
        }

        if (cid) {
          this.httpService.checkCompanySite(cid).then(
            (site) => {
              if (site !== environment.site) {
                const url = `${environment.app2_base_url}${window.location.hash}`;
                window.location.replace(url);
              }

              observer.next(false);
              observer.complete();
            },
            (err) => {
              window.location.replace(`${window.location.origin}/#/login`);
              observer.next(false);
              observer.complete();
            }
          );
          return;
        } else {
          window.location.replace(`${window.location.origin}/#/login`);
          observer.next(false);
          observer.complete();
          return;
        }
      } else {
        // get employeeId from decoded token
        const { employeeId, role } = this.helperService.getCompany();

        // for (super , onboarder , sales , engg)
        if (['super', 'onboarder', 'engg', 'sales'].includes(role)) {
          observer.next(true);
          observer.complete();
          return;
        }

        // for (admin, service writer , tech)
        this.httpService
          .getEmployeeDetails(employeeId)
          .then((employee: any) => {
            this.dataService.currentEmployeeDetails = employee;

            // set lookup preference list
            const lookupList = employee?.partLookupItems
            if(lookupList?.length) {
              this.dataService.lookupQuickSelection = lookupList.map((item) => ({
                ...item,
                status: true,
                type: 'partLookUp',
                nameSort: item?.name,
                title: item?.name,
              }));
            }

            //destruct privileges
            const { privileges } = employee;

            if (privileges?.length) {
              try {
                const colorScheme = find(privileges, { title: 'gray-scale' });

                if (colorScheme?.permitted) {
                  document.children[0].classList.add('theme-gray-scale');
                }
              } catch (err) {
                console.log(err);
              }
            }

            // build ACL
            this.aclService.buildACL(privileges);

            // complete obsv
            observer.next(true);
            observer.complete();
          })
          .catch((error) => {
            // complete obsv
            console.error(error);
            observer.next(false);
            observer.complete();

            if (error === 'Authentication failed.') {
              this.helperService.logout();
            }
          });
      }
    });
  }
}
